// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1be4-","toggleWrap":"styles_toggleWrap__3AnDX","content":"styles_content__2cDY6","selectAreaCode":"styles_selectAreaCode__336RR"};